import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { filter, Observable } from 'rxjs';
import { DriftConfiguration } from '../models/configuration.interface';

@Injectable({
  providedIn: 'root'
})
export class BedrockService {
  config: DriftConfiguration;
  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.config = {};

    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  invokeBedrockModelWithContext(
    session_id: string | null,
    prompt: string,
    selectedModel: string,
    collection_id: string,
    // TODO: Add Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filters: any
    // TODO: Add Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<any> {
    const requestBody = {
      session_id,
      prompt,
      selectedModel,
      collection_id,
      filters
    };

    return this.http.post(`${this.config.driftApi}/invoke-rag`, requestBody);
  }

  draftSection(
    prompt: string,
    context: string,
    filename: string
    // TODO: Add Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<any> {
    const requestBody = { prompt, context, filename };
    return this.http.post(`${this.config.driftApi}/draft-section`, requestBody);
  }

  // TODO: Add Type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  invokeBedrockModel(prompt: string, selectedModel: string): Observable<any> {
    const requestBody = { prompt, selectedModel };
    return this.http.post(`${this.config.driftApi}/invoke-model`, requestBody);
  }
}
